<template>
  <div
    id="app"
    class="te-body vh-100"
  >
    <router-view />
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css'; // bootstrap-vue用CSS
import './assets/css/te-cutsom.min.css'; // 基本CSS
import './assets/css/te-mcf.css'; // 會員中心前台專用CSS
import './assets/css/te-customize-color.css'; // 客製化配色用(僅前台引入)
// 客製化配色用(僅前台引入)
export default {
  name: 'App',
  created() {
    // this.$router.push("/index").catch(() =>{});
  }
};
</script>
